import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getProvinceStart,
  getDistrictStart,
  getWardStart,
  getProvinceSuccess,
  getDistrictSuccess,
  getWardSuccess,
  getProvinceFailed,
  getDistrictFailed,
  getWardFailed,
} from "../redux/location";

import {
  getProvinceApi,
  getDistrictApi,
  getWardApi,
} from "core/http/service/location";
import {
  districtsOfProvinceSelector,
  provincesSelector,
  wardsOfDistrictSelector,
} from "../redux/selector";

function* getProvinceWork() {
  const provinces = yield select(provincesSelector);

  if (provinces?.length !== 0) return;

  try {
    const res = yield call(getProvinceApi);

    yield put({
      type: getProvinceSuccess.type,
      payload: {
        key: "all",
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getProvinceFailed.type,
    });
  }
}

function* getDistrictWork(action: ReturnType<typeof getDistrictStart>) {
  const districtsOfProvince = yield select(
    districtsOfProvinceSelector(action.payload)
  );

  if (districtsOfProvince?.length !== 0) return;

  try {
    const res = yield call(getDistrictApi, action.payload);

    yield put({
      type: getDistrictSuccess.type,
      payload: {
        key: action.payload,
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getDistrictFailed.type,
    });
  }
}

function* getWardWork(action: ReturnType<typeof getWardStart>) {
  const wardsOfDistrict = yield select(wardsOfDistrictSelector(action.payload));

  if (wardsOfDistrict?.length !== 0) return;

  try {
    const res = yield call(getWardApi, action.payload);

    yield put({
      type: getWardSuccess.type,
      payload: {
        key: action.payload,
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getWardFailed.type,
    });
  }
}

function* watchGetProvince() {
  yield takeEvery(getProvinceStart.type, getProvinceWork);
}

function* watchGetDistrict() {
  yield takeEvery(getDistrictStart.type, getDistrictWork);
}

function* watchDetWard() {
  yield takeEvery(getWardStart.type, getWardWork);
}

export default function* getLocationSaga() {
  yield all([watchGetProvince(), watchGetDistrict(), watchDetWard()]);
}
